import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import Tooltip from "components/tooltip/Tooltip";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";
import ViewModal from "components/modal/ViewSubusers";
// internal imports
import { FiEye } from "react-icons/fi";
const SubusersTable = ({ subusers, perpage, currentPage }) => {
  const { serviceId, handleView, title } = useToggleDrawer();

  return (
    <>
      <ViewModal id={serviceId} title={title} data={subusers} />
      <TableBody>
        {subusers?.slice(0, perpage).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-center text-xs">
              {(currentPage - 1) * perpage + index + 1}
            </TableCell>

            <TableCell className="text-center text-xs">
              {data.agent_reference}
            </TableCell>

            <TableCell className="text-center text-xs">
              {data.reference_user}
            </TableCell>

            <TableCell className="text-center text-xs">
              {data.username}
            </TableCell>

            <TableCell className="text-center text-xs">{data.email}</TableCell>

            <TableCell className="text-center text-xs">
              {data.role_name}
            </TableCell>

            <TableCell className="text-center text-xs">
              {data.is_delete === 1 ? (
                <span className="text-red-500">Deleted</span>
              ) : data.is_active === 1 ? (
                <span className="text-green-500">Active</span>
              ) : (
                <span className="text-gray-500">Inactive</span>
              )}
            </TableCell>

            <TableCell className="text-center">
              <button
                onClick={() => handleView(data.id, "Subusers Details")}
                className="p-2 cursor-pointer text-gray-400 hover:text-green-600 focus:outline-none"
              >
                <Tooltip
                  id={data.id}
                  Icon={FiEye}
                  title="ViewOrder"
                  bgColor="#34D399"
                />
              </button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default SubusersTable;
